import { InstructorLPLocalstorageKey } from '@utils/constants'
import { getQueryParams } from '@utils/helpers'

export interface IschConfig {
  back: string
  id: string
  sd: string
}

export const getParams = (id: string) => {
  let schConfig: IschConfig

  const rawschConfig = localStorage.getItem(InstructorLPLocalstorageKey(id))

  if (rawschConfig) {
    schConfig = JSON.parse(rawschConfig)
  } else {
    const back: string = getQueryParams('back') ?? ''
    const id: string = getQueryParams('id') ?? ''
    const sd: string = getQueryParams('sd') ?? ''

    schConfig = { back, id, sd }
    setParams(id, schConfig)
  }

  return schConfig
}

export const setParams = (id: string, schConfig: IschConfig) => {
  localStorage.setItem(InstructorLPLocalstorageKey(id), JSON.stringify(schConfig))
}
